import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  IoAtOutline as AtOutline,
  IoAtCircleOutline as AtCircleOutline,
  IoChevronDown as ChevronDown,
  IoChevronUp as ChevronUp,
  IoGridOutline as GridOutline,
} from 'react-icons/io5';
import { MIGRATIS } from '../settings';

/**
 * Demo module's sidebar snippet (Items / Subitems), self-contained with its own
 * collapse state. Discovered automatically by common/shell/registry.js.
 */
const MigratisMenu = ({ onMobileClose }) => {
  const { t } = useTranslation('layout');
  const [open, setOpen] = useState(true);

  return (
    <>
      <div className="sidebar-section-header" onClick={() => setOpen((v) => !v)}>
        <GridOutline />
        <span className="sidebar-section-title">{t('migratis')}</span>
        <span className="sidebar-section-chevron">
          {open ? <ChevronUp /> : <ChevronDown />}
        </span>
      </div>
      {open && (
        <>
          <NavLink
            to="/migratis/item"
            className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
            onClick={onMobileClose}
          >
            <AtOutline />
            <span className="sidebar-label">{t('items')}</span>
          </NavLink>
          <NavLink
            to="/migratis/subitem"
            className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
            onClick={onMobileClose}
          >
            <AtCircleOutline />
            <span className="sidebar-label">{t('subitems')}</span>
          </NavLink>
        </>
      )}
    </>
  );
};

export const sidebar = [
  {
    id: 'migratis',
    order: 30,
    enabled: () => MIGRATIS,
    // Own <section> wrapper because it is a collapsible group, unlike the
    // inline credits/generator widgets.
    section: true,
    Component: MigratisMenu,
  },
];
